import { useContext } from 'react';
import { DashboardResultsContext } from '../DashboardResults.context';
import { DashboardResultsContextProps, StatsPeriods } from '../DashboardResults.types';
import ResultsHeaderDay from './ResultsHeaderDay/ResultsHeaderDay';
import moment from 'moment';
import ResultsHeaderWeek from './ResultsHeaderWeek/ResultsHeaderWeek';
import ResultsHeaderMonth from './ResultsHeaderMonth/ResultsHeaderMonth';
import ResultsHeaderCustom from './ResultsHeaderCustom/ResultsHeaderCustom';

export default () => {
  const { currentPeriod, setCurrentPeriod, setCurrentDates, setDateModalOpen } =
    useContext(DashboardResultsContext);

  const CurrentView = ({ currentPeriod }: Pick<DashboardResultsContextProps, 'currentPeriod'>) => {
    switch (currentPeriod) {
      case StatsPeriods.Day:
        return <ResultsHeaderDay />;
      case StatsPeriods.Week:
        return <ResultsHeaderWeek />;
      case StatsPeriods.Month:
        return <ResultsHeaderMonth />;
      case StatsPeriods.Custom:
        return <ResultsHeaderCustom />;
      default:
        return <ResultsHeaderDay />;
    }
  };

  return (
    <div className="flex-column">
      <div className="dashboard__results-header">
        <div
          className={`dashboard__results-header-item ${
            currentPeriod === StatsPeriods.Day ? 'dashboard__results-header-item--active' : ''
          }`}
          onClick={() => {
            setCurrentPeriod(StatsPeriods.Day);
            setCurrentDates([new Date()]);
          }}>
          <span>Jour</span>
        </div>
        <div
          className={`dashboard__results-header-item ${
            currentPeriod === StatsPeriods.Week ? 'dashboard__results-header-item--active' : ''
          }`}
          onClick={() => {
            setCurrentPeriod(StatsPeriods.Week);
            setCurrentDates([moment().weekday(0).toDate(), moment().weekday(6).toDate()]);
          }}>
          <span>Semaine</span>
        </div>
        <div
          className={`dashboard__results-header-item ${
            currentPeriod === StatsPeriods.Month ? 'dashboard__results-header-item--active' : ''
          }`}
          onClick={() => {
            setCurrentPeriod(StatsPeriods.Month);
            setCurrentDates([new Date()]);
          }}>
          <span>Mois</span>
        </div>
        <div
          className={`dashboard__results-header-item ${
            currentPeriod === StatsPeriods.Custom ? 'dashboard__results-header-item--active' : ''
          }`}
          onClick={() => {
            setCurrentPeriod(StatsPeriods.Custom);
            setCurrentDates([moment().toDate(), moment().add(1, 'day').toDate()]);
            setDateModalOpen(true);
          }}>
          <span>Période personnalisée</span>
        </div>
      </div>
      <div className="dashboard__results-header">
        <CurrentView {...{ currentPeriod }} />
      </div>
    </div>
  );
};
